"use strict";
exports.__esModule = true;
exports.isPersonTitle = void 0;
var letterDotsPattern = '^[a-z]+\\.?$';
var validTitleExpression = new RegExp(letterDotsPattern, 'gi');
function isPersonTitle(value) {
    return value.match(validTitleExpression) !== null;
}
exports.isPersonTitle = isPersonTitle;
//# sourceMappingURL=personTitle.js.map